// CanadaPRPage.js
import React from 'react';
import PRHero from '../components/PermanentResidency/Canada/PRHero';
import WhyCanadaPR from '../components/PermanentResidency/Canada/WhyCanadaPR';
import PRPathways from '../components/PermanentResidency/Canada/PRPathways';
import EligibilityRequirements from '../components/PermanentResidency/Canada/EligibilityRequirements';
import ProcessTimeline from '../components/PermanentResidency/Canada/ProcessTimeline';
import PRPricing from '../components/PermanentResidency/Canada/PRPricing';
import PRFAQSection from '../components/PermanentResidency/Canada/PRFAQSection';
import PRCTASection from '../components/PermanentResidency/Canada/PRCTASection';

const CanadaPRPage = () => {
  return (
    <div>
      <PRHero />
      <WhyCanadaPR />
      <PRPathways />
      <EligibilityRequirements />
      <ProcessTimeline />
      <PRPricing />
      <PRFAQSection />
      <PRCTASection />
    </div>
  );
};

export default CanadaPRPage;
